import { createSlice } from "@reduxjs/toolkit";

const {
  actions: {
    getTransactionDriversStart,
    getTransactionDriversSuccess,
    getTransactionDriversFailure,
    createTransactionDriverStart,
    createTransactionDriverFailure,
    createTransactionDriverSuccess,
    updateTransactionDriverStart,
    updateTransactionDriverSuccess,
    updateTransactionDriverFailure,
    updateTransactionDriverOptimistic,
    getDriversListStart,
    getDriversListSuccess,
    getDriversListFailure,
    deleteTransactionDataFailure,
    deleteTransactionDataSuccess,
    deleteTransactionDataStart
  },
  reducer,
} = createSlice({
  name: "transactionDrivers",
  initialState: {
    loading: false,
    transactionDrivers: null,
    driversList: null,
    deleteTransactionDriver: null 
  },
  reducers: {
    getTransactionDriversStart: (state) => ({
      ...state,
      loading: true,
    }),
    getTransactionDriversSuccess: (state, { payload }) => ({
      ...state,
      loading: false,
      transactionDrivers: payload,
    }),
    getTransactionDriversFailure: (state) => ({
      ...state,
      loading: false,
    }),
    getDriversListStart: (state) => ({
      ...state,
      loading: true,
    }),
    getDriversListSuccess: (state, { payload }) => ({
      ...state,
      loading: false,
      driversList: payload,
    }),
    getDriversListFailure: (state) => ({
      ...state,
      loading: false,
    }),
    createTransactionDriverStart: (state) => ({
      ...state,
      loading: true,
    }),
    createTransactionDriverSuccess: (state) => ({
      ...state,
      loading: false,
    }),
    createTransactionDriverFailure: (state) => ({
      ...state,
      loading: false,
    }),

    deleteTransactionDataStart: (state) => ({
      ...state,
      loading: true,
      error: null,
    }),
    deleteTransactionDataSuccess: (state, action) => ({
      ...state,
      loading: false,
      deleteTransactionDriver: action?.payload,
      error: null,
    }),
    deleteTransactionDataFailure: (state, action) => ({
      ...state,
      loading: false,
      deleteTransactionDriver: null,
      error: action.payload, // error message or object
    }),

    
    updateTransactionDriverStart: (state) => ({
      ...state,
    }),
    updateTransactionDriverSuccess: (state, { payload }) => ({
      ...state,
      loading: false,
    }),
    updateTransactionDriverFailure: (state, { payload }) => ({
      ...state,
      loading: false,
      transactionDrivers: state.transactionDrivers
        ? {
          ...state.transactionDrivers,
          data: state.transactionDrivers.data.map((driver) =>
            driver.transactionAgentId === payload.transactionAgentId
              ? { ...driver, status: payload.previousStatus }
              : driver
          ),
        }
        : null,
    }),

    updateTransactionDriverOptimistic: (state, { payload }) => ({
      ...state,
      transactionDrivers: state.transactionDrivers
        ? {
          ...state.transactionDrivers,
          data: state.transactionDrivers.data.map((driver) => {
            return driver.transactionAgentId === payload.transactionAgentId
              ? { ...driver, status: payload.newStatus }
              : driver;
          }),
        }
        : null,
    }),
  },
});

export default reducer;

export {
  getTransactionDriversStart,
  getTransactionDriversSuccess,
  getTransactionDriversFailure,
  createTransactionDriverStart,
  createTransactionDriverFailure,
  createTransactionDriverSuccess,
  updateTransactionDriverStart,
  updateTransactionDriverSuccess,
  updateTransactionDriverFailure,
  updateTransactionDriverOptimistic,
  getDriversListStart,
  getDriversListSuccess,
  getDriversListFailure,
  deleteTransactionDataFailure,
  deleteTransactionDataSuccess,
  deleteTransactionDataStart
};
